






































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { InputText, InputNumber } from "@/components/search/input";
import { URI_QRCODE_SCHEME_PREFIX } from "@/constants";
@Component({
  components: {
    InputNumber,
    InputText,
  },
})
export default class QrModal extends Vue {
  @Prop({ required: true }) public name: string;
  private isCollapsed = true;
  private amount = 1;
  private currency = "STEEM";
  private memo = "";
  get qrValue() {
    return this.isCollapsed ? this.name : `${URI_QRCODE_SCHEME_PREFIX}${this.formattedParams}`;
  }
  get formattedParams() {
    const params = [];
    params.push(`https://steemlogin.com/sign/transfer?from=&to=`);
    params.push(this.name);
    if (this.amount) {
      params.push(`&amount=${this.amount}`);
    }
    if (this.currency) {
      params.push(` ${this.currency}`);
    }
    params.push(`&memo=${this.memo}`);

    return params.length > 0 ? `${params.join("")}` : "";
  }
  private onInputChange(event: any) {
    const { name, value } = event.target;
    this[name] = value;
  }
  private setType(value: string) {
    this.currency = value;
  }

  @Watch("isCollapsed")
  public onStatusChanged() {
    this.amount = 1;
    this.currency = "STEEM";
  }
  public emitClose() {
    this.$emit("close");
  }
}
